import { ADD_NEWS, GET_NEWS, UPDATE_NEWS, CLEAR_CURRENT_NEWS, REMOVE_NEWS, GET_NEWS_LIST, SET_NEWS_FILTER_TYPE, SET_NEWS_POSTER_PROPS } from '@jumbo/constants/ActionTypes';

const INIT_STATE = {
  newsList: [],
  newsListMeta: null,
  currentNews: null,
  newsFilterType: {
    by_title: '',
    page: 1
  },
  newsPosterProps: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_NEWS_FILTER_TYPE:
      return {
        ...state,
        newsFilterType: action.payload
      }
    case SET_NEWS_POSTER_PROPS:
      return {
        ...state,
        newsPosterProps: action.payload
      }
    case GET_NEWS:
      return {
        ...state,
        currentNews: action.payload,
      };

    case GET_NEWS_LIST:
      return {
        ...state,
        newsList: action.payload.news,
        newsListMeta: action.payload.meta
      }

    case ADD_NEWS:
      return {
        ...state,
        newsList: state.newsList.concat(action.payload),
        currentNews: action.payload,
      };

    case UPDATE_NEWS:
      return {
        ...state,
        currentNews: action.payload,
      };

    case REMOVE_NEWS:
      return {
        ...state,
        newsList: state.newsList.filter(item => item.id !== action.payload),
      };

    case CLEAR_CURRENT_NEWS:
      return {
        ...state,
        currentNews: null,
      };

    default:
      return state;
  }
};
